'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../../node_modules/classnames/index.js');

var index = require('../../../node_modules/prop-types/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var NavPrimaryDropdown = function NavPrimaryDropdown(props) {
  var className = props.className,
      activeNavItem = props.activeNavItem,
      primaryNavData = props.primaryNavData;
  var navprimarydropdownClasses = index$1['default']('navprimarydropdown', className, 'lanl-navprimarydropdown');

  var getMenuItems = function getMenuItems() {
    if (activeNavItem && activeNavItem !== 'mobile') {
      var _ref = primaryNavData.find(function (item) {
        return item.name === activeNavItem;
      }) || {},
          menuItems = _ref.menuItems;

      return menuItems ? menuItems : [];
    } else {
      return [];
    }
  };

  var renderNavItems = function renderNavItems() {
    return getMenuItems().map(function (_ref2, i) {
      var groupName = _ref2.groupName,
          link = _ref2.link,
          groupItems = _ref2.groupItems;
      var menuLinks = groupItems.map(function (_ref3) {
        var name = _ref3.name,
            link = _ref3.link;
        return /*#__PURE__*/React__default['default'].createElement("li", {
          key: name,
          className: "dropdown-items"
        }, /*#__PURE__*/React__default['default'].createElement("a", {
          href: link
        }, name));
      });
      return /*#__PURE__*/React__default['default'].createElement("ul", {
        className: "dropdown-catagory",
        key: "item-group-".concat(i)
      }, /*#__PURE__*/React__default['default'].createElement("li", {
        className: "dropdown-items"
      }, /*#__PURE__*/React__default['default'].createElement("a", {
        href: link
      }, groupName)), menuLinks);
    });
  };

  if (activeNavItem && renderNavItems().length && activeNavItem !== 'mobile') {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: navprimarydropdownClasses,
      "data-testid": "lanl-navprimarydropdown"
    }, renderNavItems());
  } else {
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null);
  }
};

NavPrimaryDropdown.defaultProps = {};
NavPrimaryDropdown.propTypes = {
  activeNavItem: index['default'].string,
  children: index['default'].node,
  className: index['default'].string,
  primaryNavData: index['default'].array
};
exports.NavPrimaryDropdown = NavPrimaryDropdown;
exports['default'] = NavPrimaryDropdown;